import { watch } from 'vue';

import {
  isWebViewSimulatorChild,
  postStatusToSimulatorParent,
  useGenericAppStore,
} from '@nora-monorepo/ui-shared';

import { useBootstrapStore } from '#nora-ui/stores/bootstrap-store';

/**
 * Runs inside the simulated webview (the iframe) - unlike the rest of this folder, which is the
 * simulator parent. Forwards a connectivity / SSE / bootstrap-phase snapshot to the parent on every
 * change so the control panel can display it. No-op outside the simulator iframe.
 */
export function reportWebviewStatusToSimulator(): void {
  if (!isWebViewSimulatorChild()) {
    return;
  }

  const appStore = useGenericAppStore();
  const bootstrapStore = useBootstrapStore();

  watch(
    () => ({
      networkOnline: appStore.networkOnline,
      streamConnected: appStore.streamConnected,
      connectivityStatus: appStore.connectivityStatus,
      bootstrapPhase: bootstrapStore.phase,
    }),
    (status) => {
      postStatusToSimulatorParent(status);
    },
    { immediate: true },
  );
}
